import React, { useState } from 'react'
import {
  Grid, Box, Button, Divider,  TextField, Typography } from '@mui/material'

const initialFilters = {
  name: '',
  address: '',
  city: '',
  state: '',
  zip: '',
  flippedCountMin: '',
  flippedCountMax: '',
  flippedProfitMin: '',
  flippedProfitMax: ''}

export default function InvestorFilter({
  onApply,
  onClear,
}) {
  const [filters, setFilters] = useState(initialFilters)

  const handleChange = (e) => {
    const { name, value } = e.target
    setFilters((prev) => ({ ...prev, [name]: value  }))
  }

  const handleClear = () => {
    setFilters(initialFilters)
    if (onClear) onClear()
  }

  const handleApply = () => {
    if (onApply) onApply(filters)
  }

  return (
    <Box
      sx={{
        p: 0,
        minWidth: 360,
        maxWidth: 400,
        bgcolor: "#fff",
        height: "100vh",
        display: "flex",
        flexDirection: "column"
      }}>
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          px: 3,
          py: 2,
          borderBottom: 1,
          borderColor: "#eee"
        }}>
        <Typography variant="h6" sx={{
          fontWeight: 600
        }}>
          Investor Filter
        </Typography>
      </Box>
      <Divider />
      <Box
        sx={{
          px: 3,
          py: 2,
          flex: 1,
          overflow: "auto"
        }}>
        <Typography
          variant="subtitle2"
          color="textSecondary"
          gutterBottom
        >
          Investor Details
        </Typography>
        <Grid container spacing={2}>
          <Grid size={12}>
            <TextField
              label="Name"
              name="name"
              value={filters.name}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={12}>
            <TextField
              label="Mailing Address"
              name="address"
              value={filters.address}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="City"
              name="city"
              value={filters.city}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={3}>
            <TextField
              label="State"
              name="state"
              value={filters.state}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={3}>
            <TextField
              label="Zip"
              name="zip"
              value={filters.zip}
              onChange={handleChange}
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
        <Divider sx={{ my: 2 }} />
        <Typography
          variant="subtitle2"
          color="textSecondary"
          gutterBottom
        >
          Flipped Info
        </Typography>
        <Grid container spacing={2}>
          <Grid size={6}>
            <TextField
              label="Flipped Count Min"
              name="flippedCountMin"
              value={filters.flippedCountMin}
              onChange={handleChange}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="Flipped Count Max"
              name="flippedCountMax"
              value={filters.flippedCountMax}
              onChange={handleChange}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="Flipped Profit Min"
              name="flippedProfitMin"
              value={filters.flippedProfitMin}
              onChange={handleChange}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
          <Grid size={6}>
            <TextField
              label="Flipped Profit Max"
              name="flippedProfitMax"
              value={filters.flippedProfitMax}
              onChange={handleChange}
              type="number"
              fullWidth
              size="small"
            />
          </Grid>
        </Grid>
      </Box>
      <Divider />
      <Box
        sx={{
          px: 3,
          py: 2,
          display: "flex",
          justifyContent: "space-between"
        }}>
        <Button
          variant="outlined"
          color="secondary"
          onClick={handleClear}
        >
          Clear Filters
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={handleApply}
        >
          Apply Filters
        </Button>
      </Box>
    </Box>
  );
}
